import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';

export default function Sidebar({ savedPieces, onPieceSelect, isPopup = false, onClose = null }) {
  const t = useTranslations('common.newspaper.art_games.ippitsugaki.sidebar');
  const isGalleryEmpty = savedPieces.length === 0;

  return (
    <div className={`ippitsugaki__sidebar${isPopup ? ' ippitsugaki__sidebar--popup' : ''}`}>
      <div className={`ippitsugaki__card ${isGalleryEmpty ? 'ippitsugaki__card--empty' : ''}`}>
        {isPopup ? (
          <div className="generic-popup__header">
            <h2 className="generic-popup__header-text">{t('saved_gallery.title')}</h2>
            <XIcon className="generic-popup__close" onClick={onClose} />
          </div>
        ) : (
          <h2>{t('saved_gallery.title')}</h2>
        )}
        {isGalleryEmpty ? (
          <p className="ippitsugaki__empty">{t('saved_gallery.empty')}</p>
        ) : (
          <div className="ippitsugaki__gallery">
            {savedPieces.map((piece) => {
              const formatted = new Date(piece.timestamp).toLocaleString([], {
                hour: '2-digit',
                minute: '2-digit',
                month: 'short',
                day: 'numeric',
              });

              const tags = [];
              if (piece.mode === 'inspiration' && piece.inspirationTopic) {
                tags.push(t('saved_gallery.prompt_tag', { topic: piece.inspirationTopic }));
              }
              if (piece.wasEyesClosed) {
                tags.push(t('saved_gallery.eyes_closed_tag'));
              }

              const handleSelect = () => {
                if (typeof onPieceSelect === 'function') {
                  onPieceSelect(piece);
                }
              };

              const handleKeyDown = (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleSelect();
                }
              };

              return (
                <figure
                  key={piece.id}
                  className="ippitsugaki__gallery-item"
                  role="button"
                  tabIndex={0}
                  onClick={handleSelect}
                  onKeyDown={handleKeyDown}
                  aria-label={t('saved_gallery.open_aria')}
                >
                  <img src={piece.url} alt={t('saved_gallery.image_alt')} loading="lazy" />
                  <figcaption>{formatted}</figcaption>
                  {tags.length > 0 && (
                    <div className="ippitsugaki__gallery-tags">
                      {tags.map((tag) => (
                        <span key={tag} className="ippitsugaki__gallery-tag">
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                </figure>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
